module.exports = __webpack_public_path__ + "img/page_left.391c96dd.svg";